// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__QrnWi","sticky":"Header_sticky__b_UAL","hidden":"Header_hidden__J7l_E","transparent":"Header_transparent__y1l0h"};